import { render } from "./LottieLoading.vue?vue&type=template&id=1cba7d46"
import script from "./LottieLoading.vue?vue&type=script&lang=js"
export * from "./LottieLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__